export const iconFontAwesomeMedicalHealthSkullCrossbones = (
	<i className="fa-solid fa-skull-crossbones"></i>
);
